import React, { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Loader from '../shared/components/Loader';
import PATH from '../shared/constants/path.const';
import { buildLoginUrl } from '../shared/utils/returnUrl';
import { getColors } from '../theme';

const colors = getColors();
const platformLoginPage = React.lazy(() => import('../pages/common/auth/PlatformLogin.page'));
const ForgotPasswordPage = React.lazy(() => import('../pages/common/auth/ForgotPassword.page'));
const RecoverPasswordPage = React.lazy(() => import('../pages/common/auth/RecoverPassword'));

const routes = [
  {
    path: `${PATH.AUTH.LOGIN}`,
    name: 'Login',
    component: platformLoginPage,
    index: true,
  },
  {
    path: `${PATH.AUTH.FORGOT_PASSWORD}`,
    name: 'Forgot Password',
    component: ForgotPasswordPage,
  },
  {
    path: `${PATH.AUTH.RECOVERPASSWORD}`,
    name: 'Recover Password',
    component: RecoverPasswordPage,
  },
];

function RedirectToLogin() {
  const { pathname, search } = useLocation();
  return <Navigate to={buildLoginUrl(`${pathname}${search}`)} replace />;
}

function PublicRoutes() {
  const { loader } = colors;
  return (
    <Routes>
      {routes.map((route) => {
        if (route?.children) {
          return (
            <Route
              key={`route-${route.path}`}
              name={route.name}
              path={route.path}
              index={route.index}
              element={
                <Suspense fallback={<Loader overlay backgroundColor={loader.black} />}>
                  <route.component />
                </Suspense>
              }
            >
              {route.children.map((childRoute) => (
                <Route
                  key={`route-${childRoute.path}`}
                  name={childRoute.name}
                  path={childRoute.path}
                  index={childRoute.index}
                  element={
                    <Suspense fallback={<Loader overlay backgroundColor={loader.black} />}>
                      <childRoute.component />
                    </Suspense>
                  }
                />
              ))}
            </Route>
          );
        }
        return (
          <Route
            key={`route-${route.path}`}
            name={route.name}
            path={route.path}
            index={route.index}
            element={
              <Suspense fallback={<Loader overlay backgroundColor={loader.black} />}>
                <route.component />
              </Suspense>
            }
          />
        );
      })}
      <Route path="*" element={<RedirectToLogin />} />
    </Routes>
  );
}
export default PublicRoutes;
